import type { MetaFunction } from 'react-router';
import type { CreativeWork, ListItem } from 'schema-dts';
import {
    isProjectTileViewModel,
    type ProjectTileViewModel,
} from '@rocco/ui/tile-project/view-models/project';
import type { loader as projectsLoader } from '~/routes/_app.projects.$';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import { getBrowseItemListTiles } from '../util/directory-browse-item-list';
import type { StaticParentLoaders } from '../util';

/** ItemList JSON-LD for project listing and category pages. */
export const createProjectsItemListSchema: MetaFunction<
    typeof projectsLoader,
    StaticParentLoaders
> = (props) => {
    const { data, location } = props;
    if (!data) {
        return [];
    }
    const browse = getBrowseItemListTiles(data, isProjectTileViewModel);
    const tiles: ProjectTileViewModel[] =
        browse?.tiles ??
        data.projectTilesRocco?.map(({ model }) => model) ??
        [];
    if (!tiles.length) {
        return [];
    }

    const baseUrl = getMetaBaseUrl(props);
    const firstPosition =
        browse?.firstPosition ?? data.pagination?.currentRange?.from ?? 1;

    const itemListElement: ListItem[] = tiles.map((model, idx) => {
        const item: CreativeWork = {
            '@type': 'CreativeWork',
            '@id': baseUrl + model.link,
            name: model.title,
            url: baseUrl + model.link,
            image: model.images?.[0]?.src ?? '',
            creator: {
                '@type': 'Organization',
                name: model.professional.name,
                url: baseUrl + model.professional.link,
            },
        };

        return {
            '@type': 'ListItem',
            position: firstPosition + idx,
            item,
        };
    });

    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems:
                browse?.totalCount ??
                data.searchResult?.nbHits ??
                itemListElement.length,
            itemListElement,
        },
    ];
};
